






























































































































































































import _ from "lodash";
import { MaterielApi } from "../api/MaterielApi";
import { ANOMALIE_TYPES } from "../models/Materiel";
import { DateUtils } from "../utils/DateUtils";
import Modal from "../core/Modals/Modal.vue";

export default {
    name: "MouvementDetailModal",
    components: { Modal },
    props: {
        showModal: Boolean,
        mouvement: Object,
    },
    data() {
        return {
            MaterielApi: new MaterielApi(),
        };
    },
    computed: {
        preexistanteDateStr(): string {
            let preexistante =
                this.mouvement && this.mouvement.anomalie_preexistante;
            return preexistante
                ? DateUtils.sqlToDateStr(preexistante.date_mouvement)
                : "";
        },
        preexistanteTypesLabels(): Array<string> {
            let preexistante =
                this.mouvement && this.mouvement.anomalie_preexistante;
            if (!preexistante || !preexistante.anomalie_types) {
                return [];
            }
            return _.map(preexistante.anomalie_types, function (code) {
                return ANOMALIE_TYPES[code] || code;
            });
        },
    },
    methods: {
        openRapport(): void {
            this.MaterielApi.openInNewTab(
                this.MaterielApi.rapportPdfUrl(this.mouvement.id)
            );
        },
    },
};
